function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M30.41 25.788l-12.955-21.384c-0.468-0.78-1.561-1.093-2.497-0.624-0.156 0.156-0.468 0.312-0.624 0.624l-12.799 21.384c-0.468 0.78-0.312 2.029 0.624 2.497 0.156 0 0.468 0.156 0.937 0.156h25.755c0.937 0 1.873-0.78 1.873-1.873-0.156-0.312-0.156-0.624-0.312-0.78zM15.894 10.803c0.624-0.156 1.249 0.468 1.405 1.093 0 0 0 0 0 0.156 0 2.185-0.312 5.463-0.312 7.804 0 0.624-0.624 0.78-1.093 0.78-0.624 0-1.093-0.312-1.093-0.78 0-2.185-0.312-5.463-0.312-7.804 0-0.78 0.624-1.249 1.405-1.249zM15.894 24.851v0c-0.78 0-1.405-0.624-1.405-1.405s0.624-1.405 1.405-1.405c0.78 0 1.405 0.624 1.405 1.405 0 0 0 0 0 0 0 0.78-0.624 1.405-1.405 1.405z"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7b0238ceff91d5926432eb57e863a03b.svg";
export { ForwardRef as ReactComponent };